import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit, isEmpty, scrollToComponent, stringToDate, formatDate, FORMAT_DATE_BACK} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import { sellerDeepDiveOffersFilters } from "../../@signals";


export default function useSellerDeepDiveOffersEvolutionData() {
	const { showToast } = useAppToast()

	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal({})
	const chartColors = useSignal({})
	const skuName = useSignal("")
    const dateRange = useSignal()
	const isLoadingDataEvolution = useSignal(false)
	const evolutionLabel = useSignal("")

    useEffect(() => {
		if (!isEmpty(sellerDeepDiveOffersFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(`${WEBBACK_V2_API}/marketplaces/seller-deep-dive/mbl-evolution`, sellerDeepDiveOffersFilters.value).then(res => batch(() => {
                dataEvolution.value = res.chart
				chartColors.value = res.colors
				dataEvolutionKeys.value = res.chartKeys
				evolutionLabel.value = res.label
                dateRange.value = [stringToDate(sellerDeepDiveOffersFilters.value.startDate), stringToDate(sellerDeepDiveOffersFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => {
				isLoadingDataEvolution.value = false
				showToast.error()
			}
            ).finally(() => scrollToComponent('evolution-chart')))
		}) 

		if (isEmpty(sellerDeepDiveOffersFilters.value)) batch( () => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
			chartColors.value = {}
			skuName.value = ""
			evolutionLabel.value = ""
		})

	}, [JSON.stringify(sellerDeepDiveOffersFilters.value)]);

    const onChange = (e) => {
        batch(() => {
            dateRange.value = e
            sellerDeepDiveOffersFilters.value = {
                ...sellerDeepDiveOffersFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		chartColors.value = {}
		sellerDeepDiveOffersFilters.value = {}
		evolutionLabel.value = ""
	})

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		chartColors: chartColors.value,
		evolutionLabel: evolutionLabel.value,
        dateRange: dateRange.value,

        onChange,
        resetEvolutionData
	}
}